
import { Box, Divider, useTheme } from '@mui/material'
import React, { useEffect } from 'react';
import WOW from 'wowjs';
import 'animate.css';


const Brochurecomponent = ({ allbrochureimage }) => {
    useEffect(() => {
        new WOW.WOW().init();
    }, [])

    const theme = useTheme();

    return (
        <>
            <Box sx={{ margin: '30px 0px' }}>
                <Box
                    sx={{
                        width: '100%',
                        position: 'relative',

                        '&::after': {
                            position: 'absolute',
                            content: '""',
                            display: 'block',
                            background: theme.palette.background.default,
                            height: '66%',
                            width: { lg: '80%', xs: '100%' },
                            right: { lg: '10%', md: '0%', sm: '0%' },
                            top: '51%',
                            zIndex: '-1',
                            transform: 'translateY(-50%)',
                            boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
                            borderRadius: '10px',
                            display: { sm: 'block', xs: 'none' }
                        },

                    }}
                >
                    <Box sx={{
                        '&::after': {
                            position: 'absolute',
                            content: '""',
                            display: 'block',
                            borderTop: `6px solid ${theme.palette.secondary.main}`,
                            height: '10px',
                            width: { lg: '76%', md: '90%', sm: '96%' },
                            right: { lg: '12%', md: '5%', sm: '2%' },
                            top: '17%',
                            zIndex: '-1',
                            display: { sm: 'block', xs: 'none' }

                        },
                        '&::before': {
                            position: 'absolute',
                            content: '""',
                            display: 'block',
                            borderTop: `8px solid ${theme.palette.secondary.main}`,
                            height: '10px',
                            width: { lg: '76%', md: '90%', sm: '96%' },
                            right: { lg: '12%', md: '5%', sm: '2%' },
                            bottom: '15%',
                            zIndex: '-1',
                            display: { sm: 'block', xs: 'none' }

                        },
                        display: 'flex',
                        justifyContent: 'center'

                    }}>
                        <Box sx={{ padding: { md: '46px 30px', xs: '20px' }, width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <Box sx={{ width: { lg: '76%', md: '96%', xs: '100%' }, display: 'flex', flexWrap: 'wrap', padding: { sm: '10px', xs: '0px' } }}>
                                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-around', margin: { sm: '10px 0px', xs: '0px' }, flexWrap: { md: 'nowrap', xs: 'wrap' } }}>
                                    {
                                        allbrochureimage.slice(0, 2)?.map((item , index) => (
                                            <Box key={index}>
                                                {
                                                    item.img1 ? <Box className="wow animate__animated animate__pulse" sx={{ width: { lg: '430px', md: '390px', sm: '300px', xs: '100%' }, height: { lg: '617px', md: '550px', sm: '480px' }, marginTop: '10px' }}>
                                                        <img src={item.img1} width='100%' height='100%' alt={item.name} title='Creative Brochure Design' loading='lazy' />
                                                    </Box> :
                                                        <Box className="wow animate__animated animate__pulse" sx={{ width: { lg: '430px', md: '390px', sm: '300px' }, height: { lg: '617px', md: '550px', sm: '480px' }, marginTop: '10px' }}>
                                                            <img src={item.img2 } width='100%' height='100%' alt={item.name} title='Creative Brochure Design' loading='lazy' />
                                                        </Box>
                                                }

                                            </Box>
                                        ))
                                    }
                                </Box>

                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box >
        </>
    )
}

export default Brochurecomponent